import templateUrl from 'emun.salesrep/salesrep-sales-source-quarter.htm';
import salesrepConfig from 'emun.salesrep/salesrep.config';

class SalesRepSalesSourceQuarterController {
    constructor($window, $rootScope, retailerPrompt, createAutoQuery) { 
        let $ctrl = this;
        this.sourceChartLabels = ['Jan-Mar', 'Apr-Jun', 'Jul-Sep', 'Oct-Dec'];
        this.sourceChartSeries = [];
        var filter = "SalesRepID";
        if ($ctrl.context === 'manager') { filter = "ManagerId";}
		if ($ctrl.context === 'executive') { filter = ''; }
		if ($ctrl.context === 'vendor') {
			filter = "VendorId";
		}
		$ctrl.colors = salesrepConfig.chartColors;
        $ctrl.chartOptions = { 
            maintainAspectRatio: false,
            legend: { 
                display: true,
                labels: {
                    boxWidth: 5,
                    fontSize: 10
                }
            },
            elements: {
                rectangle: {
                    borderWidth: 1
                }
            },
            scales: {
                yAxes: [{
                    display: true,
                    ticks: {
                        callback: function(value, index, values) {
                            return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        },
                        fontSize: 11
                    }
                }]
            },
            tooltips: {
                enabled: true,
                callbacks: {
                    label: function(tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label ;
                        var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        //                        return label + ': ' + $filter('currency')(datasetLabel);
                    }
                }
            },
        }

        $ctrl.sourceChartData = [];
        var today = new Date();
        $ctrl.loadSourceChartData = function(args) {
            this.sourceChartLabels = ['Jan-Mar', 'Apr-Jun', 'Jul-Sep', 'Oct-Dec'];
            this.sourceChartSeries = [];
            this.sourceChartData = [];
            let $ctrl = this;
            var flags = [];
            args.forEach(function(obj) {
                if(!flags[obj.source]) {
                    flags[obj.source] = true;
                    $ctrl.sourceChartSeries.push(obj.source);
                }
            });
            $ctrl.sourceChartSeries.forEach(function(series) {
                var result = args.filter(function( obj ) {
                    return obj.source === series;
                });
                var sourceSeriesData = [0,0,0,0];
                result.forEach(function(obj) {
                    sourceSeriesData[obj.quarter - 1] = Math.round(obj.total);
                });
                $ctrl.sourceChartData.push(sourceSeriesData);
                $ctrl.chartLoaded = true;
            });
        }
        var url = 'QuerySalesDailyTotals.json?Sum=SalesDailyTotal&GroupBy=Source,Quarter&dateRange=YTD';
        if ($ctrl.repGroup) {
            if ($ctrl.repGroup !== 'ALL') {
                url = url + '&RepGroupName=' + $ctrl.repGroup;
            }
        }
        if (filter !== '') {
            url = url + '&' + filter + '=' + $ctrl.rep.id;
        }
        var quarterlySales = createAutoQuery({
            url: url,
            autoLoad: true,
            pageSize: 1000,
            onLoaded: function(args) {
                var results = [];
                args.results.forEach(function(res) {
                    var obj = {
                        total: 0,
                        source: '',
                        quarter: 0
                    };
                    obj.source = res.source;
                    obj.total += res.sumSalesDailyTotal;
                    obj.quarter = res.quarter;
                    results.push(obj);
                });
                $ctrl.loadSourceChartData(results);
            }
        });
    }
}

let SalesRepSalesSourceQuarter = {
    bindings: {
        rep: '<',
        repGroup: '@',
        context: '@'
    },
    controller: SalesRepSalesSourceQuarterController,
    templateUrl($element, $attrs) {
      return $attrs.templateUrl || templateUrl;
    }
}

export default SalesRepSalesSourceQuarter;